import { Box } from "@mui/material";
import { spacing } from "../../../../assets/styles/tokens";
import { LeadsManagementData } from "../hooks/useLeadsManagementData";
import ReportLeadsModalMobile from "./ReportLeadsModalMobile";
import RejectLeadsModalMobile from "./RejectLeadsModalMobile";
import BrandMatchModalMobile from "./BrandMatchModalMobile";
import LeadDetailDrawerMobile from "./LeadDetailDrawerMobile";
import LeadsMobileFilterBar from "./LeadsMobileFilterBar";
import LeadsMobileStatusTabs from "./LeadsMobileStatusTabs";
import LeadsMobileCardList from "./LeadsMobileCardList";
import LeadsMobileSkeleton from "./LeadsMobileSkeleton";

interface LeadsMobileProps {
  data: LeadsManagementData;
}

export default function LeadsMobile({ data }: LeadsMobileProps) {
  return (
    <Box sx={{ px: spacing.Spacing.xl.$value }}>
      <LeadsMobileStatusTabs data={data} />
      <LeadsMobileFilterBar data={data} />

      {data.isLoading ? <LeadsMobileSkeleton /> : <LeadsMobileCardList data={data} />}

      {/* Bulk select/report/reject has no mobile UI yet (the screenshot's
          card list has no selection affordance) — the single-lead actions
          (detail drawer, brand match) below still work from each card. */}
      <LeadDetailDrawerMobile data={data} />
      <ReportLeadsModalMobile data={data} />
      <RejectLeadsModalMobile data={data} />
      <BrandMatchModalMobile data={data} />
    </Box>
  );
}
